import styled from "styled-components";

const Container = styled.ul`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  list-style-type: none;
  padding-left: 0;
  margin-top: 24px;
  margin-bottom: 24px;

  li + li:before {
    padding: 4px;
    color: #6f7582;
    content: "/\00a0";
  }

  li:last-of-type {
    a {
      color: #222939;
      cursor: default;
      text-decoration: none !important;
    }
  }
`;
const Item = styled.li`
  color: #6f7582;
`;
const Link = styled.a`
  color: #6f7582;
  cursor: ${props => (props.disabled ? "default" : "pointer")};
  text-decoration: ${props => (props.disabled ? "none !important" : "default")};

  :hover {
    color: #6f7582;
  }

  :focus {
    color: #6f7582;
  }
`;

export { Container, Item, Link };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/BreadcrumbStyle.js